import { Injectable, inject } from '@angular/core';
import { StorageService } from 'digital-core';
import { AppConstants } from 'src/app/core/constants';

/**
 * Content-editor session lives in digital-core's StorageService (not the app's own
 * StorageService) because http-request.interceptor.ts already reads the same keys from
 * that instance to forward the Content-Editor-Id header — this must stay interoperable.
 */
@Injectable({ providedIn: 'root' })
export class EditorAuthService {
  private storageService = inject(StorageService);

  isLoggedIn(): boolean {
    return this.getEmail() !== null;
  }

  getEmail(): string | null {
    return this.storageService.getLocal<string>(AppConstants.STORAGE_KEYS.ContentEditorEmail) ?? null;
  }

  login(editorId: string, email: string): void {
    this.storageService.setLocal(AppConstants.STORAGE_KEYS.ContentEditorId, editorId, true);
    this.storageService.setLocal(AppConstants.STORAGE_KEYS.ContentEditorEmail, email, true);
  }

  logout(): void {
    this.storageService.setLocal(AppConstants.STORAGE_KEYS.ContentEditorId, null, true);
    this.storageService.setLocal(AppConstants.STORAGE_KEYS.ContentEditorEmail, null, true);
  }
}
